import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { withStyles } from '@material-ui/styles';
import Offline from 'static/images/closed-image.png';
import PrimaryCta from 'base/components/PrimaryCta';
import { MEDIUM_SOY, SOY } from 'base/constants/colors';

const styles = theme => ({
  root: {
    textAlign: 'center',
    marginLeft: '16px',
    marginRight: '16px',
    marginTop: '20px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '10px'
    }
  },
  image: {
    width: '196px',
    height: '192px',
    marginTop: '20px',
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '20px'
    }
  },
  title: {
    fontSize: '20px',
    fontWeight: 500,
    color: SOY,
    marginBottom: '20px'
  },
  copy: {
    marginBottom: '20px',
    fontSize: '14px',
    color: MEDIUM_SOY
  },
  cta: {
    width: '171px',
    height: '36px',
    padding: '12px 6px 12px 6px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
});

const LocationOffline = ({ classes, logoDestinationUrl }) => {
  const primaryCtaUrl = logoDestinationUrl || '/';
  return (
    <div className={classes.root}>
      <img
        className={classes.image}
        src={Offline}
        alt="offline"
        width="300px"
      />
      <div className={classes.title}>Online Ordering is currently offline</div>
      <div className={classes.copy}>Please check back soon!</div>
      <PrimaryCta
        label="BACK TO WEBSITE"
        className={classes.cta}
        href={primaryCtaUrl}
      />
    </div>
  );
};

LocationOffline.propTypes = {
  classes: PropTypes.object,
  logoDestinationUrl: PropTypes.string
};

const mapStateToProps = state => {
  const { account } = state;
  return {
    logoDestinationUrl: get(
      account,
      'online_ordering_general_settings.logo_destination_url'
    )
  };
};

export default connect(mapStateToProps)(withStyles(styles)(LocationOffline));
